import { EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { CORE_ACTIONS_KEYS, CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreAction, CoreContext } from '../core.interfaces';

export class SetInputQueryAction implements CoreAction {
  actions = {
    [CORE_ACTIONS_KEYS.setInputQuery]: ({ rootGetters, commit }: CoreContext, newQuery: string) => {
      const { searchBox: { inputPreprocessor } }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const preprocessedQuery = inputPreprocessor ? inputPreprocessor(newQuery) : newQuery;
      commit(CORE_MUTATIONS_KEYS.setInputQuery, preprocessedQuery);
    }
  };
}
